import axios from 'axios';
import { Card, showNotification } from 'design-system';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  setGraveInvitationToken,
  setInvitationTokenErrorMessage,
  setSubscriptionInvitationData,
  subscriptionInvitationToken,
} from '../../../redux/actions';
import { CONSTANTS } from '../../../service/constants';
import { authHeader, fetch_request } from '../../../service/request';
import Invitation from '../LoginForm/Invitation';
import styles from './CreateMembership.module.css';
import Header from './Header';
import InputForm from './InputForm';

const CreateMembership = ({ setUser, setHidePage, isJoinSheet = false, onSuccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const invitationToken = searchParams.get('invitation_token');
  const graveInvitation = searchParams.get('token');

  if (invitationToken) {
    dispatch(subscriptionInvitationToken(invitationToken));
  }

  useEffect(() => {
    if (graveInvitation) {
      axios
        .get(`${CONSTANTS.baseUrl}/api/grave_invitations/${graveInvitation}`)
        .then((response) => {
          const data = response.data;
          if (data.invitation_token) {
            dispatch(setGraveInvitationToken(data));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [graveInvitation]);

  useEffect(() => {
    if (invitationToken) {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
        headers: {
          ...authHeader(),
        },
      };
      fetch_request(`/api/find_subscription_invitations/${invitationToken}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            showNotification(data.error, 'error', 'auth');
            dispatch(setInvitationTokenErrorMessage(data.error));
            navigate('/register');
          } else {
            dispatch(setSubscriptionInvitationData(data));
            dispatch(setInvitationTokenErrorMessage(''));
            if (data.user_slug) {
              navigate('/sign-in');
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [invitationToken]);

  return (
    <div
      className={styles.container}
      style={{ minHeight: isJoinSheet ? 'auto' : 'calc(100vh - 120px)' }}
    >
      <div className={styles.content} style={{ width: isJoinSheet ? 'auto' : '100%' }}>
        <Card className={styles.card}>
          <div className={styles.cardContent}>
            <Header messageKey="create_new_account" headingKey="auth_register" />
            {(invitationToken || graveInvitation) && (
              <div className={styles.invitationBox}>
                <Invitation variant="register" />
              </div>
            )}
            <InputForm
              setHidePage={setHidePage}
              setUser={setUser}
              onSuccess={onSuccess}
              isJoinSheet={isJoinSheet}
            />
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CreateMembership;
